import { render, staticRenderFns } from "./StudentResident.vue?vue&type=template&id=6b36d606&scoped=true&"
import script from "./StudentResident.vue?vue&type=script&lang=js&"
export * from "./StudentResident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36d606",
  null
  
)

export default component.exports